import { Accordion, Box, Button, Heading, Image, Link, List, Stack, Text, Separator, Table } from "@chakra-ui/react";
import Wrapper from "components/layout/wrapper"

export default function Comp2024Onsite({ colorMode }) {
    const buttonStyles = {
        borderRadius: 0,
        bg: "color1",
        color: "white",
        size: { base: "md", sm: "lg" },

        //p:{base: "15px 30px 15px 15px", sm: "20px 60px 20px 35px"},
        _hover: { textDecoration: "none", bgColor: "color4" },
        width: "100%",
        maxW: "300px",
        height: "60px",
        fontWeight: "500",
        textAlign: "center",
    }
    const divderStyles = {
        borderColor: "gray",
        borderWidth: "1px",
        m: "30px 0px",
    }
    const SectionBlock = ({ img, title, children }) => {
        return (
            <Stack direction={["column", "column", "row"]} pb={"30px"} pt={"30px"}>
                <Box width={["100%", "100%", "25%"]} mb={"15px"}>
                    {img ? <Image src={img} m={["0 auto", "0 auto", "0"]} maxW={"200px"} /> : ""}
                </Box>
                <Box width={["100%", "100%", "60%"]}>
                    {title ? (
                        <Heading as={"h4"} mt={"0px !important"} mb={"15px"}>
                            {title}
                        </Heading>
                    ) : (
                        ""
                    )}

                    {children}
                </Box>
            </Stack>
        )
    }

    const AItem = ({ title, children }) => {
        return (
            <Accordion.Item borderColor="#666" w={"100%"}>
                <Heading as="h4" mt={"0px !important"} color="white">
                    <Accordion.ItemTrigger p="15px 0" _focus={{ outline: 0 }}>
                        <Accordion.ItemIndicator color="color1" boxSize={6} />
                        <Box color={"black"} fontSize={"20px"} fontWeight={500} pl={"8px"}>
                            {title}
                        </Box>
                    </Accordion.ItemTrigger>
                </Heading>
                <Accordion.ItemContent pb={4} pl={0} pr={"2px"} mt={"0px"} pt={"0px"}>
                    <Box p="0px 0px 20px 20px" ml={"0px"} className="body">
                        {children}
                    </Box>
                </Accordion.ItemContent>
            </Accordion.Item>
        )
    }

    return (
        <Wrapper className={"body colorMode--" + colorMode} py="10px" mt={"30px"}>
            <Heading as={"h1"} mt={"0px !important"} fontSize={["28px !important", "34px"]}>
                Your Steps to Complications 2024!
            </Heading>
            <SectionBlock
                img={"https://assets.crfconnect.com/meetings/cto2023/page-content/icon5.png"}
                title={"STEP 1: PREPARE YOUR POWERPOINT"}
            >
                <Box mb={"15px"}>
                    <List.Root ml={"0px"}>
                        <List.Item>Must be a PPTX File.</List.Item>
                        <List.Item>
                            Include a 2nd slide disclosure
                            {/*(*/}
                            {/*<Text as={"span"} color={"color4"}>*/}
                            {/*    24 months of information*/}
                            {/*</Text>*/}
                            {/*).*/}
                        </List.Item>
                        <List.Item>
                            Use the Complications 2024{" "}
                            <Link color={"color2"} href={"/logos-and-templates"}>
                                slide template
                            </Link>
                            .
                        </List.Item>
                        <List.Item>Include a last slide summary/conclusion.</List.Item>
                        <List.Item>
                            Follow{" "}
                            <Link color={"color2"} href={"/guidelines"}>
                                Presentation Guidelines
                            </Link>
                            .
                        </List.Item>
                    </List.Root>
                </Box>
                <Accordion.Root collapsible w={"100%"}>
                    <AItem title={"File Type"}>
                        <List.Root mt={"0px !important"} ml={"11px"} pl={"2px !important"}>
                            <List.Item>
                                <strong>PowerPoint</strong> in the .pptx only and formatted to 16:9 aspect ratio.
                                <List.Root margin={"0px !important"} listStyleType={"-"}>
                                    <List.Item>
                                        Convert your Keynote file to PowerPoint (.pptx) and check formatting before
                                        uploading.
                                    </List.Item>
                                </List.Root>
                            </List.Item>
                            <List.Item>
                                <Link href={"/logos-and-templates"}>Download Complications 2024 templates</Link> for
                                your slide background.
                            </List.Item>
                        </List.Root>
                    </AItem>
                    <AItem title={"Presentation Requirements"}>
                        <Text>
                            Ensure your presentation meets all presentation guidelines. Presentations found to not meet
                            requirements will be contacted by CRF.
                        </Text>
                        <List.Root mt={"0px !important"} ml={"11px"} pl={"2px !important"}>
                            <List.Item fontWeight={"500"}>
                                <strong>Required Disclosure</strong>
                            </List.Item>
                            <List.Root margin={"0px !important"} listStyleType={"-"}>
                                <List.Item>
                                    You MUST have disclosure information in the second slide of your presentation.{" "}
                                    {/*<Text as="span" color={"color4"}>*/}
                                    {/*    ACCME now requires 24 months of disclosure information.*/}
                                    {/*</Text>*/}
                                    <List.Root>
                                        <List.Item>
                                            The presentation system does not create and insert a disclosure slide.
                                        </List.Item>
                                    </List.Root>
                                </List.Item>
                                <List.Item>
                                    <Link color={"color2"} href={"/logos-and-templates"}>
                                        Download
                                    </Link>{" "}
                                    the required template and select the relevant slide: Nothing to disclose OR you have
                                    disclosures.
                                </List.Item>
                            </List.Root>
                        </List.Root>
                        <List.Root mt={"0px !important"} ml={"11px"} pl={"2px !important"}>
                            <List.Item fontWeight={"500"}>Summary/Conclusion</List.Item>
                            <List.Root margin={"0px !important"} listStyleType={"-"}>
                                <List.Item>
                                    The last slide of your presentation should be a summary/conclusion slide.{" "}
                                </List.Item>
                                <List.Item>
                                    Your last slide must not be a hidden slide. Because of PowerPoint programming, your
                                    last slide may be shown even if hidden.
                                </List.Item>
                            </List.Root>
                        </List.Root>
                        <br />
                        <Link href={"/guidelines"} _hover={{ textDecoration: "none" }}>
                            <Button {...buttonStyles} mt={"15px"}>
                                PRESENTATION GUIDELINES
                            </Button>
                        </Link>
                    </AItem>
                </Accordion.Root>
            </SectionBlock>
            <Separator {...divderStyles} display={["none", "none", "block"]} />
            <SectionBlock
                img={"https://assets.crfconnect.com/meetings/cto2023/page-content/icon6.png"}
                title={"STEP 2: UPLOAD YOUR PRESENTATION  "}
            >
                <Box color={"black"}>
                    <Text as="strong" color={"color4"}>
                        Early upload (72 hours prior) is necessary
                    </Text>{" "}
                    to screen for technical issues that may create problems during presentations. Failure to comply with
                    the 72-hour deadline will jeopardize the onsite presentation experience.
                </Box>
                <Link href={"https://ctitech.click/ln3eme2"} _hover={{ textDecoration: "none" }} target="_blank">
                    <Button {...buttonStyles} mt={"30px"} mb={"15px"}>
                        UPLOAD YOUR FILES
                    </Button>
                </Link>
                <Box mb={"20px"}>
                    <List.Root as="ol" mt={"0px !important"} ml={"11px"} pl={"2px !important"}>
                        <List.Item fontSize={"19px"}>Enter your email address and password.</List.Item>
                        <List.Root margin={"0px !important"} listStyleType={"-"}>
                            <List.Item>First time? Click “Forgot your password?” to create a password.</List.Item>
                            <List.Item>
                                Use the email that received the communication to upload, the same email in the CRF
                                Faculty system.
                            </List.Item>
                        </List.Root>

                        <List.Item fontSize={"19px"}>
                            Check that the correct file appears in the correct presentation slot.
                        </List.Item>
                    </List.Root>
                </Box>
                <Text as={"small"} fontStyle={"italic"} color={"black"}>
                    Use the following browsers: Google Chrome, Firefox, or Safari. If you do not have access to one of
                    these browsers, please send Encore your presentation via email or an online storage service such as
                    Dropbox or Box, and they will upload the files for you. You must include talk title, date, time,
                    presenter, etc.
                </Text>
            </SectionBlock>
            <Separator {...divderStyles} />
            <SectionBlock
                img={"https://assets.crfconnect.com/meetings/cto2023/page-content/icon7.png"}
                title={"STEP 3: JOIN US ON-SITE"}
                mb={"0px"}
            >
                <Text mb={"15px"}>
                    • Check your file(s) in Speaker Ready.
                    <br />
                    • Arrive at the room prior to your session.
                    <br />
                    • Present.
                    <br />• Enjoy Complications 2024.
                </Text>
                <Accordion.Root collapsible>
                    <AItem title={"Check Your Presentation In Speaker Ready"}>
                        <Table.Root
                            className={"table--plain"}
                            mb={"0px !important"}
                            mt={"15px !important"}
                            css={{ "& td": { padding: "0px", pb: "8px !important" } }}
                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.ColumnHeader colSpan={3} fontWeight={"600"}>
                                        Location | Hours
                                    </Table.ColumnHeader>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell rowSpan={4}>
                                        Alcove, Lobby Level,
                                        <br /> Grand Hyatt Seattle
                                    </Table.Cell>
                                    <Table.Cell>Thursday, August 1</Table.Cell>
                                    <Table.Cell>
                                        4:00<small>PM</small>-6:00<small>PM</small>
                                    </Table.Cell>
                                </Table.Row>

                                <Table.Row>
                                    <Table.Cell>Friday, August 2</Table.Cell>
                                    <Table.Cell>
                                        6:30<small>AM</small>-6:00<small>PM</small>
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>Saturday, August 3</Table.Cell>
                                    <Table.Cell>
                                        7:00<small>AM</small>-4:45<small>PM</small>
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table.Root>
                        <Text mt={"7px !important"}>
                            <small>
                                Hours are subject to change. Last admission is 30 minutes prior to the closing time.
                            </small>
                        </Text>
                    </AItem>
                    <AItem title={"Presentation Technology"}>
                        <List.Root mt={"0px !important"} ml={"11px"} pl={"2px !important"}>
                            <List.Item>
                                <strong>Personal laptops at the podium are not permitted.</strong> Each room is equipped
                                with a presentation laptop connected to the presentation management system.
                            </List.Item>
                            <List.Item>
                                <strong>Presentation Timer</strong>
                                <List.Root>
                                    <List.Item>
                                        The presentation management system will have an automated countdown clock per
                                        the time allotted in the agenda. The system is set-up to ensure presentations
                                        keep to time and presentations that go over time will be cut-off.
                                    </List.Item>
                                </List.Root>
                            </List.Item>
                            {/*sx={{ td: { padding: "0px" } }}*/}
                            {/*{*/}
                            {/*    "li" : {*/}
                            {/*    _before:{{ content: `""`}}*/}
                            {/*}*/}
                            {/*_before={{ content: `"- "` }}*/}
                        </List.Root>
                    </AItem>
                </Accordion.Root>
            </SectionBlock>
            <Separator {...divderStyles} display={["none", "none", "block"]} />
            <SectionBlock mb={"0px"}>
                <Heading as={"h1"} mt={"0px !important"}>
                    ENJOY Complications 2024!
                </Heading>
            </SectionBlock>
            <Separator {...divderStyles} />
            <SectionBlock last={true}>
                <Heading mt={"0px !important"}>Technical Issue or Questions? </Heading>
                <Text fontWeight={"600 !important"} color={"color1"}>
                    Technical Queries When Uploading
                </Text>
                <br />
                <Link _hover={{ textDecoration: "none" }} href={"mailto:c1@encoresupport.com"}>
                    <Button {...buttonStyles} mb={"15px"}>
                        Email Encore
                    </Button>
                </Link>
                <br />
                <Text fontWeight={"600 !important"} color={"color1"}>
                    Other Questions (including program items)
                </Text>
                <br />
                <Link _hover={{ textDecoration: "none" }} href={"/contact-us"}>
                    <Button {...buttonStyles} mb={"15px"}>
                        Contact Us
                    </Button>
                </Link>
            </SectionBlock>
        </Wrapper>
    );
}
